import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import {
  usePostUpdateItemAttributeMutation,useGetItemDetailsDataMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManager  from "../../../../Components/FileAttachmentManager";
import Attachment from "../../../../utils/Attachment";
const EditForm = () => {
    const navigate = useNavigate();
     const location = useLocation();
          const IdData = location.state?.ItemId;
          const [podata, setpodata] = useState('')
    
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [UpdateItemAttribute] = usePostUpdateItemAttributeMutation();

  // tab1
  const [Numeric_Values, setNumeric_Values] = useState(false);
  const [AttributeName, setAttributeName] =useState("");
  const [FromRange, setFromRange] =useState("");
  const [ToRange, setToRange] =useState("");
  const [Increment, setIncrement] =useState("");
const [selected_default_item_attribulte_data, setselected_default_item_attribulte_data] = useState([]);
  // console.log('tbl:',selected_default_item_attribulte_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    Numeric_Values: false,
    AttributeName: false,
  });

const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
 const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

    useEffect(() => {
        if (IdData) {
            itemDetails({ doctype: 'Item Attribute', name: IdData })
                .unwrap()
                .then((response) => {
                    const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                    console.log(item, "Api response");
                    setNumeric_Values(item.numeric_values);
                    setAttributeName(item.attribute_name);
                    setFromRange(item.from_range);
                    setToRange(item.to_range)
                    setIncrement(item.increment)
                    setselected_default_item_attribulte_data(item.item_attribute_values)
                   setAttachmentsList(docinfo.attachments); // ✅ Correct place
                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No Id Data found in location state');
        }
    }, [IdData, itemDetails]);

  const handleSubmit = async () => {
//  console.log('tbl:',selected_default_item_attribulte_data)
setFieldErrors({
    Numeric_Values: false,
    AttributeName: false,
    });

    let hasError = false;
    const newErrors = {
      AttributeName: !AttributeName,
    };
    const FirsthasInvalidItem = "";
    if (FirsthasInvalidItem) {
      newErrors.items = true;
    }
    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);

 
  if (!AttributeName) {
    setptype("Error");
    setError("Please fill Attribute Name.");
    setShowError(true);
    return;
  }



  const payload = {
attribute_name: IdData,
  // attribute_name: AttributeName,               // Required
  numeric_values: Numeric_Values,                    // 0 = False, 1 = True
  from_range: FromRange,                      // Required if numeric_values=1
  to_range: ToRange,                        // Required if numeric_values=1
  increment: Increment,                       // Required if numeric_values=1
  item_attribute_values: selected_default_item_attribulte_data ? selected_default_item_attribulte_data : [],

};

console.log('update Item Attribute payload:',payload)
  try {
    const response = await UpdateItemAttribute(payload); // RTK mutation or fetch

     function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Updation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

    setpo_response(response.data);
    setError("Item Attribute updated successfully!");
    setptype("Success");
    setShowError(true);
    // Navigate after a short delay (e.g., 2 seconds)
    setTimeout(() => {
      navigate("/master/item-attribute/item-attribute-list"); // 🔁 Replace with your actual route
    }, 2000);
  } catch (err) {
    setError(err?.data?.message || "Unexpected error occurred.");
    setptype("Error");
    setShowError(true);
  }
};
  return (
    <FormLayout
      title="Edit Item Attribute"
      breadcrumbs={[
        { label: "Item Attribute"},
        { label: "Item Attribute List", url: "/master/item-attribute/item-attribute-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/item-attribute/create-item-attribute"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

         <Attachment doctype="Item Attribute"  docname={IdData}  />    

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    setselected_default_item_attribulte_data={setselected_default_item_attribulte_data}
                    selected_default_item_attribulte_data={selected_default_item_attribulte_data}
                    Numeric_Values={{
                      Numeric_Values: Numeric_Values,
                      setNumeric_Values: setNumeric_Values,
                      Numeric_Values: Numeric_Values,
                      Error: fieldErrors.Numeric_Values,
                    }}
                    AttributeName={{
                      AttributeName: AttributeName,
                      setAttributeName: setAttributeName,
                      AttributeName: AttributeName,
                      Error: fieldErrors.AttributeName,
                    }}
                    FromRange={{
                      FromRange: FromRange,
                      setFromRange: setFromRange,
                      FromRange: FromRange,
                      Error: fieldErrors.FromRange,
                    }}
                    ToRange={{
                      ToRange: ToRange,
                      setToRange: setToRange,
                      ToRange: ToRange,
                      Error: fieldErrors.ToRange,
                    }}
                    Increment={{
                      Increment: Increment,
                      setIncrement: setIncrement,
                      Increment: Increment,
                      Error: fieldErrors.Increment,
                    }}
                    
                  />
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default EditForm;
